export default {
    computed: {
        genderTranslation() {
            return (this.contact.gender == 'M' ? this.$t('default.Men') : this.$t('default.Woman'));
        },
    }
}